const rankingItems = [
  { rank: 1, title: '台北娜娜 · 最新独家视频爆料', views: '12.8万', tag: '视频', change: 'up' },
  { rank: 2, title: '莫里秀 · 不为人知的黑料真相', views: '10.5万', tag: '揭秘', change: 'up' },
  { rank: 3, title: '玩偶姐姐 · 近期精彩内容合集', views: '9.2万', tag: '合集', change: 'same' },
  { rank: 4, title: '暗网吃瓜 · 本月人物热度榜', views: '7.6万', tag: '榜单', change: 'up' },
  { rank: 5, title: '51吃瓜 · 社区热议话题TOP5', views: '6.3万', tag: '社区', change: 'down' },
  { rank: 6, title: '台北娜娜 · 粉丝见面会独家直击', views: '5.1万', tag: '现场', change: 'new' },
];

const rankColors: Record<number, string> = {
  1: 'text-accent-500',
  2: 'text-accent-400',
  3: 'text-secondary-400',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          吃瓜热度榜单
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          实时热度排行，看看谁最受关注
        </p>
        <div className="mt-8 space-y-3">
          {rankingItems.map((item, i) => (
            <a
              key={i}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="group flex items-center gap-4 rounded-xl border border-background-200/60 bg-background-100/50 p-4 transition-all duration-300 hover:border-primary-500/30 cursor-pointer"
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                  rankColors[item.rank] || 'text-foreground-400'
                } bg-background-50`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-400 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="px-1.5 py-0.5 rounded bg-primary-500/10 text-xs text-primary-400">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-400">{item.views}</span>
                <i
                  className={`text-sm ${
                    item.change === 'up'
                      ? 'ri-arrow-up-line text-primary-500'
                      : item.change === 'down'
                        ? 'ri-arrow-down-line text-foreground-400'
                        : item.change === 'new'
                          ? 'ri-sparkling-line text-accent-400'
                          : 'ri-subtract-line text-foreground-400'
                  }`}
                ></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}